// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/AgentStats/AgentStatsReports.css */

.agent-report-page {
    width: min(1180px, calc(100vw - 32px));
    margin: 18px auto 36px;
    color: #243447;
}

.agent-report-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 14px;
    margin-bottom: 14px;
    border: 1px solid rgba(36, 81, 111, 0.16);
    border-radius: 8px;
    background: linear-gradient(135deg, #ffffff, #eef7fb);
    box-shadow: 0 16px 36px rgba(36, 52, 71, 0.1);
}

.agent-report-toolbar-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 230px;
    min-width: 0;
}

.agent-report-toolbar h1 {
    margin: 0;
    color: #16324f;
    font-size: 1.35rem;
    font-weight: 900;
    letter-spacing: 0;
}

.agent-report-updated {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #5d7281;
    font-size: 0.76rem;
    font-weight: 700;
}

.agent-report-updated i {
    font-size: 0.72rem;
}

.agent-report-toolbar button {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 38px;
    border: none;
    border-radius: 7px;
    background: #0f7c73;
    color: white;
    cursor: pointer;
    font-weight: 900;
    padding: 9px 14px;
    transition: transform 160ms ease, filter 160ms ease;
}

.agent-report-toolbar button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
}

.agent-report-toolbar button:disabled {
    cursor: not-allowed;
    opacity: 0.75;
    transform: none;
}

/* Search box */
.agent-report-search {
    display: flex;
    align-items: center;
    position: relative;
    flex: 1 1 260px;
    max-width: 360px;
    min-width: 0;
}

.agent-report-search input {
    width: 100%;
    height: 38px;
    border: 1px solid rgba(54, 76, 99, 0.2);
    border-radius: 999px;
    padding: 9px 34px;
    font-size: 0.86rem;
    background: #ffffff;
    transition: border-color 160ms ease, box-shadow 160ms ease;
}

.agent-report-search input:focus {
    outline: none;
    border-color: #0f7c73;
    box-shadow: 0 0 0 3px rgba(15, 124, 115, 0.16);
}

.agent-report-search-icon {
    position: absolute;
    left: 13px;
    color: #8a9cab;
    font-size: 0.8rem;
    pointer-events: none;
}

.agent-report-search-clear {
    position: absolute;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    border-radius: 50%;
    background: rgba(54, 76, 99, 0.1);
    color: #5d7281;
    cursor: pointer;
    font-size: 0.68rem;
    transition: background 160ms ease, color 160ms ease;
}

.agent-report-search-clear:hover {
    background: rgba(54, 76, 99, 0.2);
    color: #243447;
}

.agent-report-error {
    margin-bottom: 12px;
    padding: 10px 12px;
    border: 1px solid rgba(220, 53, 69, 0.24);
    border-radius: 7px;
    background: #fff1f2;
    color: #b42335;
    font-weight: 800;
}

.agent-report-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 14px;
}

.agent-report-summary div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 13px 14px;
    border: 1px solid rgba(36, 81, 111, 0.2);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(36, 52, 71, 0.08);
}

.agent-report-summary span {
    color: #5d7281;
    font-size: 0.78rem;
    font-weight: 900;
    text-transform: uppercase;
}

.agent-report-summary strong {
    color: #0f7c73;
    font-size: 1.25rem;
    font-weight: 900;
}

.agent-report-summary-available {
    color: #1e9e5c;
}

/* Loading & empty states */
.agent-report-loading,
.agent-report-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 56px 20px;
    border: 1px dashed rgba(36, 81, 111, 0.22);
    border-radius: 8px;
    background: #ffffff;
    color: #5d7281;
    font-weight: 700;
    text-align: center;
}

.agent-report-empty i {
    font-size: 1.8rem;
    color: #b7c3cd;
}

.agent-report-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid rgba(15, 124, 115, 0.18);
    border-top-color: #0f7c73;
    border-radius: 50%;
    animation: agent-report-spin 800ms linear infinite;
}

@keyframes agent-report-spin {
    to { transform: rotate(360deg); }
}

.agent-report-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(245px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}

.agent-report-card {
    border: 1px solid rgba(22, 50, 79, 0.16);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.09);
    overflow: hidden;
    text-align: left;
}

.agent-report-card-available {
    border-color: rgba(24, 134, 82, 0.34);
    background: #f3fbf6;
    box-shadow: 0 14px 30px rgba(24, 134, 82, 0.14);
}

.agent-report-card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 12px;
    background: linear-gradient(135deg, #16324f, #0f7c73);
    color: white;
    text-align: left;
}

.agent-report-card-available .agent-report-card-top {
    background: linear-gradient(135deg, #16724a, #23a566);
}

.agent-report-card-top h2 {
    margin: 0 0 3px;
    font-size: 0.98rem;
    font-weight: 900;
}

.agent-report-card-top span {
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    opacity: 0.86;
}

.agent-report-card-top-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    flex: 0 0 auto;
}

.agent-report-card-top-meta strong {
    padding: 4px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.18);
    font-size: 0.8rem;
}

.agent-report-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 0.66rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    white-space: nowrap;
}

.agent-report-badge--available {
    background: rgba(255, 255, 255, 0.92);
    color: #1e9e5c;
}

.agent-report-badge--unavailable {
    background: rgba(255, 255, 255, 0.22);
    color: #ffffff;
}

.agent-report-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}

.agent-report-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 10px 12px;
}

.agent-report-metrics span {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    color: #5d7281;
    font-size: 0.76rem;
    font-weight: 800;
    text-align: left;
}

.agent-report-metrics b {
    color: #243447;
}

/* Activity breakdown bar */
.agent-report-bar {
    display: flex;
    height: 7px;
    margin: 0 12px 10px;
    border-radius: 999px;
    overflow: hidden;
    background: #eef2f6;
}

.agent-report-bar-segment {
    height: 100%;
}

.agent-report-bar-segment--idle { background: #1d5fa7; }
.agent-report-bar-segment--oncall { background: #ef6f53; }
.agent-report-bar-segment--wrapup { background: #f4a300; }
.agent-report-bar-segment--hold { background: #8a5fd1; }
.agent-report-bar-segment--notavailable { background: #c0392b; }
.agent-report-bar-segment--other { background: #8a9cab; }

.agent-report-states {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 0 12px 12px;
}

.agent-report-state-chip {
    border-radius: 999px;
    border: 1px solid transparent;
    font-size: 0.7rem;
    font-weight: 900;
    padding: 4px 7px;
}

.agent-report-state-chip--idle {
    background: #e8f2ff;
    color: #1d5fa7;
    border-color: rgba(29, 95, 167, 0.16);
}

.agent-report-state-chip--oncall {
    background: #fdece6;
    color: #c84a2d;
    border-color: rgba(239, 111, 83, 0.24);
}

.agent-report-state-chip--wrapup {
    background: #fff4df;
    color: #a9710a;
    border-color: rgba(244, 163, 0, 0.26);
}

.agent-report-state-chip--hold {
    background: #f1ecfb;
    color: #6b3fb0;
    border-color: rgba(138, 95, 209, 0.24);
}

.agent-report-state-chip--notavailable {
    background: #fdecec;
    color: #b42335;
    border-color: rgba(192, 57, 43, 0.24);
}

.agent-report-state-chip--other,
.agent-report-state-chip--empty {
    background: #eef2f6;
    color: #5d7281;
    border-color: rgba(54, 76, 99, 0.14);
}

@media (max-width: 780px) {
    .agent-report-page {
        width: min(100% - 20px, 1180px);
    }

    .agent-report-toolbar {
        align-items: stretch;
        flex-direction: column;
    }

    .agent-report-search {
        max-width: none;
    }

    .agent-report-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 420px) {
    .agent-report-summary {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/AgentStats/AgentStatsReports.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;IACI,sCAAsC;IACtC,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,qDAAqD;IACrD,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,kCAAkC,mBAAmB,EAAE;AACvD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,kCAAkC,mBAAmB,EAAE;AACvD,0CAA0C,mBAAmB,EAAE;AAC/D,mCAAmC,mBAAmB,EAAE;;AAExD;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qCAAqC;AACzC;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* src/components/routes/Other/AgentStats/AgentStatsReports.css */\n\n.agent-report-page {\n    width: min(1180px, calc(100vw - 32px));\n    margin: 18px auto 36px;\n    color: #243447;\n}\n\n.agent-report-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n    padding: 14px;\n    margin-bottom: 14px;\n    border: 1px solid rgba(36, 81, 111, 0.16);\n    border-radius: 8px;\n    background: linear-gradient(135deg, #ffffff, #eef7fb);\n    box-shadow: 0 16px 36px rgba(36, 52, 71, 0.1);\n}\n\n.agent-report-toolbar-title {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1 1 230px;\n    min-width: 0;\n}\n\n.agent-report-toolbar h1 {\n    margin: 0;\n    color: #16324f;\n    font-size: 1.35rem;\n    font-weight: 900;\n    letter-spacing: 0;\n}\n\n.agent-report-updated {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #5d7281;\n    font-size: 0.76rem;\n    font-weight: 700;\n}\n\n.agent-report-updated i {\n    font-size: 0.72rem;\n}\n\n.agent-report-toolbar button {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    height: 38px;\n    border: none;\n    border-radius: 7px;\n    background: #0f7c73;\n    color: white;\n    cursor: pointer;\n    font-weight: 900;\n    padding: 9px 14px;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.agent-report-toolbar button:hover {\n    filter: brightness(1.05);\n    transform: translateY(-1px);\n}\n\n.agent-report-toolbar button:disabled {\n    cursor: not-allowed;\n    opacity: 0.75;\n    transform: none;\n}\n\n/* Search box */\n.agent-report-search {\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex: 1 1 260px;\n    max-width: 360px;\n    min-width: 0;\n}\n\n.agent-report-search input {\n    width: 100%;\n    height: 38px;\n    border: 1px solid rgba(54, 76, 99, 0.2);\n    border-radius: 999px;\n    padding: 9px 34px;\n    font-size: 0.86rem;\n    background: #ffffff;\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.agent-report-search input:focus {\n    outline: none;\n    border-color: #0f7c73;\n    box-shadow: 0 0 0 3px rgba(15, 124, 115, 0.16);\n}\n\n.agent-report-search-icon {\n    position: absolute;\n    left: 13px;\n    color: #8a9cab;\n    font-size: 0.8rem;\n    pointer-events: none;\n}\n\n.agent-report-search-clear {\n    position: absolute;\n    right: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border: none;\n    border-radius: 50%;\n    background: rgba(54, 76, 99, 0.1);\n    color: #5d7281;\n    cursor: pointer;\n    font-size: 0.68rem;\n    transition: background 160ms ease, color 160ms ease;\n}\n\n.agent-report-search-clear:hover {\n    background: rgba(54, 76, 99, 0.2);\n    color: #243447;\n}\n\n.agent-report-error {\n    margin-bottom: 12px;\n    padding: 10px 12px;\n    border: 1px solid rgba(220, 53, 69, 0.24);\n    border-radius: 7px;\n    background: #fff1f2;\n    color: #b42335;\n    font-weight: 800;\n}\n\n.agent-report-summary {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 10px;\n    margin-bottom: 14px;\n}\n\n.agent-report-summary div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 13px 14px;\n    border: 1px solid rgba(36, 81, 111, 0.2);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(36, 52, 71, 0.08);\n}\n\n.agent-report-summary span {\n    color: #5d7281;\n    font-size: 0.78rem;\n    font-weight: 900;\n    text-transform: uppercase;\n}\n\n.agent-report-summary strong {\n    color: #0f7c73;\n    font-size: 1.25rem;\n    font-weight: 900;\n}\n\n.agent-report-summary-available {\n    color: #1e9e5c;\n}\n\n/* Loading & empty states */\n.agent-report-loading,\n.agent-report-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 56px 20px;\n    border: 1px dashed rgba(36, 81, 111, 0.22);\n    border-radius: 8px;\n    background: #ffffff;\n    color: #5d7281;\n    font-weight: 700;\n    text-align: center;\n}\n\n.agent-report-empty i {\n    font-size: 1.8rem;\n    color: #b7c3cd;\n}\n\n.agent-report-spinner {\n    width: 30px;\n    height: 30px;\n    border: 3px solid rgba(15, 124, 115, 0.18);\n    border-top-color: #0f7c73;\n    border-radius: 50%;\n    animation: agent-report-spin 800ms linear infinite;\n}\n\n@keyframes agent-report-spin {\n    to { transform: rotate(360deg); }\n}\n\n.agent-report-card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(245px, 1fr));\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.agent-report-card {\n    border: 1px solid rgba(22, 50, 79, 0.16);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 14px 30px rgba(36, 52, 71, 0.09);\n    overflow: hidden;\n    text-align: left;\n}\n\n.agent-report-card-available {\n    border-color: rgba(24, 134, 82, 0.34);\n    background: #f3fbf6;\n    box-shadow: 0 14px 30px rgba(24, 134, 82, 0.14);\n}\n\n.agent-report-card-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 12px;\n    background: linear-gradient(135deg, #16324f, #0f7c73);\n    color: white;\n    text-align: left;\n}\n\n.agent-report-card-available .agent-report-card-top {\n    background: linear-gradient(135deg, #16724a, #23a566);\n}\n\n.agent-report-card-top h2 {\n    margin: 0 0 3px;\n    font-size: 0.98rem;\n    font-weight: 900;\n}\n\n.agent-report-card-top span {\n    display: block;\n    font-size: 0.75rem;\n    font-weight: 700;\n    opacity: 0.86;\n}\n\n.agent-report-card-top-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 6px;\n    flex: 0 0 auto;\n}\n\n.agent-report-card-top-meta strong {\n    padding: 4px 8px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.18);\n    font-size: 0.8rem;\n}\n\n.agent-report-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 8px;\n    border-radius: 999px;\n    font-size: 0.66rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n}\n\n.agent-report-badge--available {\n    background: rgba(255, 255, 255, 0.92);\n    color: #1e9e5c;\n}\n\n.agent-report-badge--unavailable {\n    background: rgba(255, 255, 255, 0.22);\n    color: #ffffff;\n}\n\n.agent-report-badge-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n}\n\n.agent-report-metrics {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n    padding: 10px 12px;\n}\n\n.agent-report-metrics span {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 8px;\n    color: #5d7281;\n    font-size: 0.76rem;\n    font-weight: 800;\n    text-align: left;\n}\n\n.agent-report-metrics b {\n    color: #243447;\n}\n\n/* Activity breakdown bar */\n.agent-report-bar {\n    display: flex;\n    height: 7px;\n    margin: 0 12px 10px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: #eef2f6;\n}\n\n.agent-report-bar-segment {\n    height: 100%;\n}\n\n.agent-report-bar-segment--idle { background: #1d5fa7; }\n.agent-report-bar-segment--oncall { background: #ef6f53; }\n.agent-report-bar-segment--wrapup { background: #f4a300; }\n.agent-report-bar-segment--hold { background: #8a5fd1; }\n.agent-report-bar-segment--notavailable { background: #c0392b; }\n.agent-report-bar-segment--other { background: #8a9cab; }\n\n.agent-report-states {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    padding: 0 12px 12px;\n}\n\n.agent-report-state-chip {\n    border-radius: 999px;\n    border: 1px solid transparent;\n    font-size: 0.7rem;\n    font-weight: 900;\n    padding: 4px 7px;\n}\n\n.agent-report-state-chip--idle {\n    background: #e8f2ff;\n    color: #1d5fa7;\n    border-color: rgba(29, 95, 167, 0.16);\n}\n\n.agent-report-state-chip--oncall {\n    background: #fdece6;\n    color: #c84a2d;\n    border-color: rgba(239, 111, 83, 0.24);\n}\n\n.agent-report-state-chip--wrapup {\n    background: #fff4df;\n    color: #a9710a;\n    border-color: rgba(244, 163, 0, 0.26);\n}\n\n.agent-report-state-chip--hold {\n    background: #f1ecfb;\n    color: #6b3fb0;\n    border-color: rgba(138, 95, 209, 0.24);\n}\n\n.agent-report-state-chip--notavailable {\n    background: #fdecec;\n    color: #b42335;\n    border-color: rgba(192, 57, 43, 0.24);\n}\n\n.agent-report-state-chip--other,\n.agent-report-state-chip--empty {\n    background: #eef2f6;\n    color: #5d7281;\n    border-color: rgba(54, 76, 99, 0.14);\n}\n\n@media (max-width: 780px) {\n    .agent-report-page {\n        width: min(100% - 20px, 1180px);\n    }\n\n    .agent-report-toolbar {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .agent-report-search {\n        max-width: none;\n    }\n\n    .agent-report-summary {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 420px) {\n    .agent-report-summary {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
